module.exports = __webpack_public_path__ + "img/20190801163747QQ截图20190731174351.8a6ac40f.png";